module.exports = __webpack_public_path__ + "static/media/Quicksand-Regular.5fe9a9de.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Quicksand-Regular.woff
// module id = 89
// module chunks = 31